import { Component, OnInit, Input } from '@angular/core';
import { HomeService } from 'src/app/services/home.service';

@Component({
  selector: 'app-marc',
  templateUrl: './marc.component.html',
  styleUrls: ['./marc.component.css']
})
export class MarcComponent implements OnInit {
  @Input() bibid: string;
  marc: any[];
  constructor(private homeService: HomeService) { }

  ngOnInit(): void {
    this.homeService.getMARC(this.bibid).subscribe((items: any) => {
      // Apply subfield highlighting
      this.marc = items.map((tag: any) => ({
        ...tag,
        Subfield: this.highlightSubfields(tag.Subfield)
      }));
    });

  }

  copyToClipboard(): void {
    if (!this.marc || this.marc.length === 0) {
      return;
    }

    // Format MARC data as text based on user pattern: ^\d{3}[\t].[\t].[\t].+[\n]|^\d{3}[\t].[\t].[\t].+
    let marcText = '';

    this.marc.forEach((tag, index) => {
      const ind1 = tag.Indicator1 && tag.Indicator1.trim() !== '' ? tag.Indicator1 : '.';
      const ind2 = tag.Indicator2 && tag.Indicator2.trim() !== '' ? tag.Indicator2 : '.';
      const subfield = this.stripHtml(tag.Subfield);

      marcText += `${tag.TagID}\t${ind1}\t${ind2}\t${subfield}`;

      if (index < this.marc.length - 1) {
        marcText += '\n';
      }
    });

    // Copy to clipboard
    navigator.clipboard.writeText(marcText).then(() => {
      alert('MARC record copied to clipboard!');
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  }

  private stripHtml(html: string): string {
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  highlightSubfields(text: string): string {
    if (!text) return '';
    // Regex to match $ followed by a character (subfield code)
    // Using a span with a class for styling
    return text.replace(/\$([a-z0-9])/g, '<span class="marc-subfield-code">$$$1</span>');
  }
}
